// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2X7W7","selected":"Chip_selected__DI4xk"};